const s = {
  name: "UserBackground",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,16c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6s-2.7,6-6,6C16.7,22,14,19.3,14,16z M20,12c-2.2,0-4,1.8-4,4
			s1.8,4,4,4c2.2,0,4-1.8,4-4S22.2,12,20,12z"/>
		<path class="st0" d="M0,0h40v32h-7v8h-2v-9c0-2.8-2.2-5-5-5H14c-2.8,0-5,2.2-5,5v9H7v-8H0V0z M7.1,30c0.5-3.4,3.4-6,6.9-6h12
			c3.5,0,6.4,2.6,6.9,6H38V2H2v28H7.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UserBackground
};
